import React from 'react';
import { ThumbnailStyled } from './thumbnail.component.style';
import ImgImagePlaceholder from '@assets/img/img_picture_placeholder.svg';
export const Thumbnail = (props) => {
    var _a;
    return React.createElement(ThumbnailStyled, { size: props.size, src: (_a = props.image) !== null && _a !== void 0 ? _a : ImgImagePlaceholder });
};
